import React from "react";
import { useHistory, useParams } from "react-router-dom";
import "../../user/pages/dashboard/dashboard.css";

const StatsPage = () => {
  const history = useHistory();
  
  const { category } = useParams();


  const handleCategorySelect = (category) => {
    history.push(`/statsDetails/${category}`);
  };

  return (
    <div className="mainContent">
        <h1 style={{color: 'white'}}>Stats for {category}</h1>
      <div className="gamelogButton">
        <div className="gamelogItem">
            
          <div className="featuredMoneyContainer">
            <span className="innerText">Select Stats</span>
            <div className="dropdownContent">
              <a onClick={() => handleCategorySelect("category1")}>
                Stats 1
              </a>
              <a onClick={() => handleCategorySelect("category2")}>
                Stats 2
              </a>
              <a onClick={() => handleCategorySelect("category3")}>
                Stats 3
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsPage;
